import React, { useEffect, useState } from "react";

import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import Topbar from "./global/Topbar";
import Sidebar from "./global/Sidebar";
import { HelmetProvider } from "react-helmet-async";
import TawkToChat from "./component.js/TawkToChat";

const Home = () => {
  const navigate = useNavigate();
  const [isSidebar, setIsSidebar] = useState(false);
  let location = useLocation();

  let userData = sessionStorage.getItem("lssbAdminData");
  // let stringData = JSON.parse(userData);
  //console.log(userData);
  if (!userData) {
    return <Navigate to="/login" />;
  } else {
    //console.log("Valid token");
  }

  const handleSideBarClose = () => {
    setIsSidebar(false);
  };
  
  const toggleSidebar = () => {
    setIsSidebar(!isSidebar);
  };

  return (
    <HelmetProvider>
      <div id="popup-root" className="app bg-[#ffffff] flex ">
        <Sidebar isSidebarOpen={isSidebar} onClose={handleSideBarClose} />
        <main className="bg-[white] w-full overflow-x-hidden">
          <Topbar setIsSidebar={toggleSidebar} userData={userData} />
          <Outlet />
        </main>
      </div>
      <TawkToChat />
    </HelmetProvider>
  );
};

export default Home;
